import DbService from 'resources/db.service';
import schema from './advanced-fields.schema';

const service = new DbService('advanced_fields', { schema });

export default Object.assign(service, {});
